import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import FormFieldError from './FormFieldError';

export default function Input({
	children,
	fieldIsValid = () => true,
	getFieldErrorMessages = () => [],
	label,
	name,
	onChange,
	required,
	type = 'text',
	value,
	visibleErrors = false,
}) {
	const inputRef = useRef();

	useEffect(() => {
		const input = inputRef.current;
		if (!input) return;
		const handleNativeInput = (e) => onChange(e);
		input.addEventListener('change', handleNativeInput);

		return () => {
			input.removeEventListener('change', handleNativeInput);
		};
	}, []);

	const inputAttributes = {
		id: name,
		name,
		onChange,
		type: type,
		value,
		ref: inputRef,
	};

	required && (inputAttributes.required = 'required');

	const formFieldClasses = ['form-field'];

	if (value && fieldIsValid(name)) {
		formFieldClasses.push('form-field--valid');
	} else if (!fieldIsValid(name) && visibleErrors) {
		formFieldClasses.push('form-field--error');
	}

	return (
		<div className="form-field-wrapper" data-field-name={name}>
			<div className={formFieldClasses.join(' ')} data-field-type={type} data-field-name={name}>
				<label htmlFor={name}>{label}</label>
				<input {...inputAttributes} />
				{children}
			</div>
			{visibleErrors && !fieldIsValid(name) && <FormFieldError messages={getFieldErrorMessages(name)} />}
		</div>
	);
}

Input.propTypes = {
	children: PropTypes.node,
	fieldIsValid: PropTypes.func,
	getFieldErrorMessages: PropTypes.func,
	label: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	required: PropTypes.bool,
	type: PropTypes.string,
	value: PropTypes.string.isRequired,
	visibleErrors: PropTypes.bool,
};
